import { render, staticRenderFns } from "./questionAnalysis.vue?vue&type=template&id=55c92a5c&scoped=true"
import script from "./questionAnalysis.vue?vue&type=script&lang=js"
export * from "./questionAnalysis.vue?vue&type=script&lang=js"
import style0 from "./questionAnalysis.vue?vue&type=style&index=0&id=55c92a5c&lang=scss"
import style1 from "./questionAnalysis.vue?vue&type=style&index=1&id=55c92a5c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c92a5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55c92a5c')) {
      api.createRecord('55c92a5c', component.options)
    } else {
      api.reload('55c92a5c', component.options)
    }
    module.hot.accept("./questionAnalysis.vue?vue&type=template&id=55c92a5c&scoped=true", function () {
      api.rerender('55c92a5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/questionType/questionAnalysis.vue"
export default component.exports